import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import { styled } from '@mui/system';

import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const StyledCard = styled(Card, {
  shouldForwardProp: muiPropForwarding('isSelected', 'ownState')
})(({ theme, ownState }) => {
  const ownCardState = ownState?.card?.(theme);
  const styles = {
    backgroundColor: theme.palette.card.background.main,
    ...ownCardState
  };

  return styles;
});

function LocationsPaper({ children, ...rest }) {
  const { isSelected, ownState } = rest;
  return (
    <StyledCard isSelected={isSelected} ownState={ownState}>
      {children}
    </StyledCard>
  );
}

LocationsPaper.propTypes = {
  isSelected: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,

  ownState: PropTypes.object
};

export default LocationsPaper;
